import { FC } from 'react';

import multicreationAlertFailedButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/auction/multicreation/multicreation_alert_failed_button_click';
import { Alert, Button, ButtonStack } from '@hh.ru/magritte-ui';
import { ExclamationCircleFilledSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    title: 'MultiCreationAuction.CreationFailedAlert.title',
    description: 'MultiCreationAuction.CreationFailedAlert.description',
    repeat: 'MultiCreationAuction.CreationFailedAlert.repeat',
    cancel: 'MultiCreationAuction.CreationFailedAlert.cancel',
};

interface CreationFailedAlertProps {
    isVisible: boolean;
    closeAlert: () => void;
    createCampaigns: () => void;
}

export const CreationFailedAlert: FC<CreationFailedAlertProps> = ({ isVisible, closeAlert, createCampaigns }) => {
    const trls = useTrls();

    const handleCreateCampaigns = () => {
        multicreationAlertFailedButtonClick({ buttonName: 'multicreation_alert_failed_repeat' });
        createCampaigns();
        closeAlert();
    };

    const handleCloseAlert = () => {
        multicreationAlertFailedButtonClick({ buttonName: 'multicreation_alert_failed_cancel' });
        closeAlert();
    };

    return (
        <>
            <Alert
                title={trls(TrlKeys.title)}
                description={trls(TrlKeys.description)}
                buttons={
                    <ButtonStack stretched layout="horizontal">
                        <Button
                            data-qa="cancel-button"
                            mode="secondary"
                            style="accent"
                            stretched
                            onClick={handleCloseAlert}
                        >
                            {trls(TrlKeys.cancel)}
                        </Button>
                        <Button
                            data-qa="repeat-button"
                            mode="primary"
                            style="accent"
                            stretched
                            onClick={handleCreateCampaigns}
                        >
                            {trls(TrlKeys.repeat)}
                        </Button>
                    </ButtonStack>
                }
                visible={isVisible}
                onClose={handleCloseAlert}
            >
                <ExclamationCircleFilledSize24
                    initialColor="negative"
                    backgroundStyle="negative-secondary"
                    padding={12}
                    borderRadius="halfHeight"
                />
            </Alert>
        </>
    );
};
